import React from "react";
import "./balance-panel.css";
import { Network } from "utils/network";
import IconButton from "components/icon-button/IconButton";
// import Button from "components/button-v1/Button";
import {
  CopyIconV1,
  ExternalLinkIconV1,
  QrCodeIconV1,
} from "images/image-component";
import { Skeleton } from "components/skeleton";

interface Props {
  balance: number;
  isBalanceLoading: boolean;
  cardStatus: string | undefined;
  cardAlias: string;
  cardType: string | undefined;
  network: Network | undefined;
  tokenSymbol: string;
  /** No card on the selected network — show an empty state, not zeroes. */
  isCardMissing?: boolean;
  copied: boolean;
  onCopy: () => void;
  onOpenExplorer: () => void;
  onOpenQr: () => void;
  onRecharge?: () => void;
}

function BalancePanel({
  balance,
  isBalanceLoading,
  cardStatus,
  cardAlias,
  cardType,
  network,
  tokenSymbol,
  isCardMissing,
  copied,
  onCopy,
  onOpenExplorer,
  onOpenQr,
  onRecharge,
}: Props) {
  const statusClass = cardStatus
    ? `v1-status-${cardStatus.toLowerCase().replace(/\s+/g, "-")}`
    : "";

  return (
    <div className="v1-panel">
      <div className="v1-balance-row">
        <div>
          <div className="v1-balance-label">Balance</div>
          <div className="v1-balance-amount">
            {isBalanceLoading ? (
              <Skeleton />
            ) : isCardMissing ? (
              <div className="v1-balance-value v1-balance-value--empty">—</div>
            ) : (
              <>
                <div className="v1-balance-value">
                  {typeof balance === "number" ? balance.toFixed(2) : "0.00"}
                </div>
                <div className="v1-balance-unit">{tokenSymbol}</div>
              </>
            )}
          </div>
        </div>
        {cardStatus && !isCardMissing && (
          <span className={`v1-status-pill ${statusClass}`}>{cardStatus}</span>
        )}
      </div>

      {isCardMissing ? (
        <div className="v1-panel-empty">
          No card found on {network?.label ?? "this network"}.
        </div>
      ) : (
        <div className="v1-address-row">
          <span className="v1-addr-label">Addr</span>
          <span className="v1-address-value">{cardAlias}</span>

          <IconButton
            ariaLabel="Copy address"
            onClick={onCopy}
            tooltip={copied ? "Copied!" : undefined}
          >
            <CopyIconV1 />
          </IconButton>

          <IconButton ariaLabel="View on explorer" onClick={onOpenExplorer}>
            <ExternalLinkIconV1 />
          </IconButton>

          <IconButton ariaLabel="Show QR" onClick={onOpenQr}>
            <QrCodeIconV1 />
          </IconButton>
        </div>
      )}
    </div>
  );
}

export default BalancePanel;
